import PageTitle from './PageTitle';

export * from './PageTitle';
export default PageTitle;
